import { useCallback } from 'react';
import { StorageFileAuditGrid } from '@jarvis/platform-ui';
import { listStorageFileAudits } from '../../../api/storageFileAudit';

export function StorageFileAuditPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listStorageFileAudits>[0]) => listStorageFileAudits(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <StorageFileAuditGrid
          loadPage={loadPage}
          stateStorageKey="webopsui:storage-file-audit-grid:v2"
        />
      </div>
    </div>
  );
}
